import type { ComputedEntityDelta } from '../compile/action-computed-delta';
import type { CreatureVitalityCompileResult } from '../types';

type Row = Record<string, unknown>;
export interface SwarmCardProjection {
    actorId: string; templateId: string; delta: ComputedEntityDelta; definitionInputs: Row;
}
/** A swarm selection changes classification, dice totals and virtual member counts only.
 * Inventory, abilities, defenses, positions and every other held cluster stay borrowed. */
export function swarmCardProjection(actorId: string, templateId: string, quantity: number, held: Row,
    selection: { layers: Row; vitality: CreatureVitalityCompileResult; definitionInputs: Row }): SwarmCardProjection {
    const mirrors: ComputedEntityDelta = { set: [], unset: [] };
    for (const key of ['creature_template', 'v_dice_multiplier', 'swarm_width_lanes']) {
        const path = ['item_layer_types', key];
        if (key in selection.layers) mirrors.set.push({ path, value: selection.layers[key] });
        else mirrors.unset.push(path);
        if (key in held) {
            if (key in selection.layers) mirrors.set.push({ path: [key], value: selection.layers[key] });
            else mirrors.unset.push([key]);
        }
    }
    for (const [key, value] of Object.entries({ swarm_members: quantity, swarm_members_start: quantity, swarm_tier: quantity })) {
        const path = ['encounter_creatures', key];
        if (quantity) mirrors.set.push({ path, value }); else mirrors.unset.push(path);
    }
    return { actorId, templateId, definitionInputs: selection.definitionInputs,
        delta: { set: ['v_die', 'v_avg', 'v_max_from_v_dice'].map(key => ({ path: ['vitality', key],
            value: selection.vitality[key as keyof CreatureVitalityCompileResult] })), unset: [], mirrors } };
}
